import React, { useEffect } from 'react';
import { useScrollLock } from '../../../hooks/useScrollLock';
import { useEscapeKey } from '../../../hooks/useEscapeKey';

interface DtePdfModalLayoutProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  maxWidth?: string;   // ej. 'max-w-4xl'
  maxHeight?: string;  // ej. 'max-h-[85vh]'
  children?: React.ReactNode;
  closeOnBackdrop?: boolean;
}

const DtePdfModalLayout: React.FC<DtePdfModalLayoutProps> = ({
  isOpen,
  onClose,
  title = 'Vista previa DTE',
  maxWidth = 'max-w-4xl',
  maxHeight = 'max-h-[85vh]',
  children,
  closeOnBackdrop = true,
}) => {
  useScrollLock(isOpen);
  useEscapeKey(() => {
    if (isOpen) onClose();
  });

  useEffect(() => {
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    if (!closeOnBackdrop) return;
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/70 px-3 sm:px-6"
      role="dialog"
      aria-modal="true"
      onMouseDown={handleBackdropClick}
    >
      <div
        className={`w-full ${maxWidth} rounded-xl bg-white shadow-2xl ring-1 ring-black/10 dark:bg-meta-4`}
        style={{ overflow: 'hidden' }}
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b border-stroke px-4 py-3 dark:border-strokedark">
          <h2 className="text-sm font-semibold text-gray-900 dark:text-white sm:text-base">
            {title}
          </h2>
          <button
            onClick={onClose}
            aria-label="Cerrar"
            className="rounded p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700 dark:text-gray-300 dark:hover:bg-white/10"
          >
            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.89 10L19.5 2.39a1 1 0 10-1.42-1.42L10.47 8.59 2.86 0.97A1 1 0 101.44 2.39L9.06 10l-7.62 7.61a1 1 0 101.42 1.42l7.61-7.61 7.61 7.61a1 1 0 101.42-1.42L11.89 10z"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className={`px-0 py-0 ${maxHeight}`} style={{ height: 'auto' }}>
          {/* El contenedor interno controla el tamaño del iframe */}
          <div className="h-[70vh] w-full sm:h-[75vh]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DtePdfModalLayout;
